exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container[data-v-569b1fcc]{width:100%;height:100%;background-color:#fafafa;display:flex;align-items:center}.login-wrap[data-v-569b1fcc]{width:1160px;height:600px;border-radius:8px;box-shadow:0 0 30px 0 rgba(57,126,253,.1);margin:0 auto;padding:68px 0 0 520px;background-color:#fff;background-repeat:no-repeat;background-position:0 0;background-size:520px 600px}.login-wrap h2[data-v-569b1fcc]{margin-bottom:60px;text-align:center}.login-wrap .form-box[data-v-569b1fcc]{width:360px;margin:0 auto}", ""]);

// exports
